"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _ui = require("@probeton/ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ContactsInfo = function ContactsInfo(_ref) {
  var contacts = _ref.contacts,
      onContactClick = _ref.onContactClick;
  return /*#__PURE__*/_react["default"].createElement(_core.List, null, contacts.map(function (_ref2) {
    var _id = _ref2._id,
        avatar = _ref2.avatar,
        fullName = _ref2.fullName;
    return /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
      icon: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
        src: avatar && avatar.src
      }),
      text: fullName,
      onClick: function onClick() {
        return onContactClick(_id);
      },
      key: _id
    });
  }));
};

var _default = ContactsInfo;
exports["default"] = _default;